<template>
  <section class="dlgs">
    <h3 v-if="title" class="dlgs-head">
      <span class="dlgs-title">{{ title }}</span>
      <span class="dlgs-rule" aria-hidden="true"></span>
    </h3>
    <p v-if="description" class="dlgs-desc">{{ description }}</p>
    <div class="dlgs-fields">
      <slot></slot>
    </div>
  </section>
</template>

<script setup>
/**
 * SECTION TITRÉE DU CORPS.
 *
 * Dix-neuf modales titraient leurs groupes de champs à la main, en `<h3>` ou en
 * `.form-section`, avec autant d'échelles typographiques. Un formulaire qui
 * dépasse six champs se lit par blocs ou ne se lit pas.
 *
 * Le titre est un intertitre discret (13 px, capitales), pas un second titre de
 * fenêtre : il ne doit jamais concurrencer celui de l'en-tête.
 */
defineProps({
  title: { type: String, default: null },
  description: { type: String, default: null }
})
</script>

<style scoped>
.dlgs {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
}

.dlgs-head {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  margin: 0;
}

.dlgs-title {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--color-text-tertiary);
  white-space: nowrap;
}

.dlgs-rule {
  flex: 1;
  height: 1px;
  background: var(--color-border-light);
}

.dlgs-desc {
  margin: 0;
  font-size: var(--font-size-sm);
  line-height: var(--line-height-normal);
  color: var(--color-text-tertiary);
}

.dlgs-fields {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
}

/* Les champs du kit portent leur propre marge basse, pensée pour un formulaire
   de page. Dans une fenêtre, c'est l'écart de la pile qui fait le rythme :
   cumuler les deux ajoutait 16 px sous chaque champ. */
.dlgs-fields :deep(.form-group),
.dlgs-fields :deep(.checkbox-wrapper) {
  margin-bottom: 0;
}
</style>
